export default class CallbackHelpers {
  // Create steady references to the built-in functions, so that they can be compared, and used in React hooks
  private static _noOp = () => {
    /* Intentionally left blank*/
  };
  private static _asyncNoOp = async () => {
    /* Intentionally left blank*/
  };
  private static _returnFalse = () => false;
  private static _returnTrue = () => true;
  private static _returnUndefined = () => undefined as undefined;
  private static _returnNull = () => null as null;
  private static _returnEmptyArray = (): any[] => [];
  private static _throwNotImplemented = () => {
    throw new Error('Not implemented');
  };

  public static get NoOp() {
    return this._noOp;
  }

  public static get AsyncNoOp() {
    return this._asyncNoOp;
  }

  public static get ReturnFalse() {
    return this._returnFalse;
  }

  public static get ReturnTrue() {
    return this._returnTrue;
  }

  public static get ReturnUndefined() {
    return this._returnUndefined;
  }

  public static get ReturnNull() {
    return this._returnNull;
  }

  public static get ReturnEmptyArray() {
    return this._returnEmptyArray;
  }

  public static get ThrowNotImplemented() {
    return this._throwNotImplemented;
  }
}
